// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Galeria_ListaImagensResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

import type { Galeria_ImageRow } from './Galeria_ImageRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Galeria_ListaImagensResponseDados {
items: Galeria_ImageRow[]
}

export type Galeria_ListaImagensResponse = ApiResponse<Galeria_ListaImagensResponseDados>;

registerResponseContract('Galeria_ListaImagensResponse', {
  items: {
    type: 'array',
    required: true,
    items: {
      compromisso_id:               { type: 'number',  required: true },
      compromisso_franquia_id:      { type: 'number',  required: true },
      cliente_nome:                 { type: 'string',  required: true },
      compromisso_operador_user_id: { type: 'string',  required: true },
      operador:                     { type: 'string',  required: false },
      franquia:                     { type: 'string',  required: false },
      bairro:                       { type: 'string',  required: false },
      valor:                        { type: 'string',  required: false },
      inicio:                       { type: 'string',  required: true },
      fim:                          { type: 'string',  required: true },
      status:                       { type: 'string',  required: true },
      compromisso_servico_id:       { type: 'number',  required: true },
      servico:                      { type: 'string',  required: true },
      antes:                        { type: 'string',  required: false },
      depois:                       { type: 'string',  required: false },
      antes_url:                    { type: 'string',  required: false },
      antes_thumbnail_url:          { type: 'string',  required: false },
      depois_url:                   { type: 'string',  required: false },
      depois_thumbnail_url:         { type: 'string',  required: false },
    },
  },
})
